<template>
  <div class="home-banner">
    <van-swipe
      :autoplay="3000"
      :show-indicators="false"
      style="width: 100%; height: 100%"
    >
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img
          v-lazy="image"
          style="
            width: 100%;
            height: 100%;
            border-radius: 10px;
          "
        />
      </van-swipe-item>
    </van-swipe>
    <div class="home-notify">
      <van-notice-bar
        left-icon="volume-o"
        :text="noticeStr"
      >
      <template #left-icon>
        <img src="../../../assets/images/notify.png" style="width: .5rem;margin-right:.2rem ;" />
      </template>
    </van-notice-bar>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeBannerView',
  data () {
    return {
      images: [],
      noticeStr:''
    }
  },
  mounted(){
    this.getBanner()
    this.getNotice()
  },
  methods:{
    async getBanner () {
      await this.$http({
        method: 'post',
        url: 'bannerlst',
        data: { type: 2 }
      }).then((data) => {
        this.images = data.data
      })
    },
    async getNotice () {
      await this.$http({
        method: 'post',
        url: 'noticeList'
      }).then((data) => {
        data.data.forEach((element,index) => {
          this.noticeStr += (index+1)+ '.' +element.name + ' ' + element.content.replace(/<[^>]+>/g, '');
        });
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home-banner {
  border-radius: 10px;
  width: 96%;
  margin: .075rem auto;
  height: 4.5rem;
  position: relative;
  .home-notify {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 101%;
  }
}
</style>
<style lang="scss">
.home-notify {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  .van-notice-bar {
    background: rgba(0, 0, 0, 0.6) !important;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    color: #fff !important;
  }
}
</style>
